export default {"src":"/_next/static/media/diploma-green-flag.e35c2eba.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};